import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search, NotificationsOutlined, DarkMode, Refresh, Settings, Language, Menu, Logout } from '@mui/icons-material';
import toast from 'react-hot-toast';

const Header = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [notifications, setNotifications] = useState([
    { id: 1, text: 'New client request received', unread: true, time: '2 min ago' },
    { id: 2, text: 'Meeting reminder: Portfolio Review', unread: true, time: '15 min ago' },
    { id: 3, text: 'Task completed: Customer onboarding', unread: false, time: '1 hour ago' },
    { id: 4, text: 'System update completed', unread: false, time: '2 hours ago' },
  ]);
  const [showNotifications, setShowNotifications] = useState(false);

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    // Implement search functionality here
  };

  const toggleNotifications = () => {
    setShowNotifications(!showNotifications);
  };

  const handleLogout = () => {
    // Clear authentication
    localStorage.removeItem('isAuthenticated');
    // Show success message
    toast.success('Successfully logged out!');
    // Redirect to login page
    navigate('/login');
  };

  const unreadCount = notifications.filter(n => n.unread).length;

  return (
    <header className="bg-[#1A1A1A] border-b border-[#2A2A2A] px-6 py-4 shadow-lg flex items-center min-h-[72px]">
      <div className="flex items-center justify-between w-full">
        <div className="flex items-center flex-1">
          <div className="flex items-center space-x-4">
            <div className="relative">
              <input
                type="text"
                placeholder="Search customers, products..."
                value={searchQuery}
                onChange={handleSearch}
                className="w-80 pl-10 pr-4 py-3 rounded-xl bg-[#2A2A2A] border border-[#3A3A3A] text-[#FFFFFF] placeholder-[#B0B0B0] focus:outline-none focus:border-[#B4E50D] focus:ring-2 focus:ring-[#B4E50D] focus:ring-opacity-20 transition-all duration-200"
              />
              <Search className="absolute left-3 top-3.5 text-[#B0B0B0]" />
            </div>
            <div className="text-sm text-[#B0B0B0] bg-[#2A2A2A] px-3 py-1 rounded-lg">⌘K</div>
          </div>
        </div>
        
        <div className="flex items-center space-x-4">
          {/* Action buttons */}
          <div className="flex items-center space-x-2">
            <button className="p-2 hover:bg-[#2A2A2A] rounded-lg text-[#B0B0B0] hover:text-[#B4E50D] transition-colors" title="Dark Mode">
              <DarkMode />
            </button>
            <button className="p-2 hover:bg-[#2A2A2A] rounded-lg text-[#B0B0B0] hover:text-[#B4E50D] transition-colors" title="Refresh">
              <Refresh />
            </button>
            <button className="p-2 hover:bg-[#2A2A2A] rounded-lg text-[#B0B0B0] hover:text-[#B4E50D] transition-colors" title="Settings">
              <Settings />
            </button>
            <button className="p-2 hover:bg-[#2A2A2A] rounded-lg text-[#B0B0B0] hover:text-[#B4E50D] transition-colors" title="Language">
              <Language />
            </button>
          </div>

          {/* Notifications */}
          <div className="relative">
            <button 
              onClick={toggleNotifications}
              className="relative p-2 hover:bg-[#2A2A2A] rounded-lg text-[#B0B0B0] hover:text-[#B4E50D] transition-colors"
            >
              <NotificationsOutlined />
              {unreadCount > 0 && (
                <span className="absolute -top-1 -right-1 bg-[#FF6B6B] text-[#FFFFFF] text-xs rounded-full w-5 h-5 flex items-center justify-center font-bold">
                  {unreadCount}
                </span>
              )}
            </button>

            {showNotifications && (
              <div className="absolute right-0 mt-2 w-80 bg-[#1A1A1A] rounded-xl shadow-2xl border border-[#2A2A2A] py-2 z-50">
                <div className="px-4 py-3 border-b border-[#2A2A2A]">
                  <h3 className="text-[#FFFFFF] font-semibold">Notifications</h3>
                </div>
                {notifications.map(notification => (
                  <div 
                    key={notification.id}
                    className={`px-4 py-3 hover:bg-[#2A2A2A] transition-colors cursor-pointer ${
                      notification.unread ? 'bg-[#2A2A2A] border-l-4 border-l-[#B4E50D]' : ''
                    }`}
                  >
                    <div className="text-[#FFFFFF] text-sm">{notification.text}</div>
                    <div className="text-[#B0B0B0] text-xs mt-1">{notification.time}</div>
                  </div>
                ))}
              </div>
            )}
          </div>
          
          {/* Profile */}
          <div className="flex items-center space-x-3 pl-4 border-l border-[#2A2A2A]">
            <div className="w-10 h-10 bg-[#B4E50D] rounded-xl flex items-center justify-center">
              <span className="text-[#0A0A0A] font-bold text-sm">AR</span>
            </div>
            <div className="text-right">
              <div className="font-medium text-[#FFFFFF]">Al Razzaq</div>
              <div className="text-sm text-[#B0B0B0]">Relationship Manager</div>
            </div>
            <button
              onClick={handleLogout}
              className="ml-3 p-2 hover:bg-[#2A2A2A] rounded-lg text-[#B0B0B0] hover:text-[#FF6B6B] transition-colors"
              title="Logout"
            >
              <Logout />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;